import React, { useCallback, useEffect, useMemo, useState } from 'react'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import { Typography } from '@mui/material'
import StepperCustom from '../../../components/step/Stepper'
import { useTranslation } from 'react-i18next'
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { MyOnlineCourseShoppingCartApi } from '../../../api/my_online_course_shopping_cart/my_online_course_shopping_cart.api'
import { useDispatch } from 'react-redux'
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal'
import { PublishOnlineCourseApi } from '../../../api/publish-online-course/publish-online-course.api'
import StatusCustom from '../../../components/status/statusCustom'
import { renderStatus } from './enum/shopping-cart.enum'

export default function ShoppingCart() {
    const [step, setStep] = useState<any>(0);
    const [search, setSearch] = useState<any>('')
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();

    const { t } = useTranslation();
    const allStep: any[] = useMemo(() => [
        { name: t('สินค้าในตะกร้า'), isAccept: true, icon: null, disabled: false },
        { name: t('ประวัติการทำรายการ'), isAccept: true, icon: null, disabled: false },

    ], [t,]);


    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: "ระบบคอร์สออนไลน์",
                        key: "1",
                        pathName: routeName.cms.MeetingCalendar,
                    },
                    {
                        name: "ตะกร้าสินค้า",
                        key: "2",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },


                ]}
            />
            <section className="my-4">
                <Typography variant="h3">ตะกร้าสินค้า</Typography>
            </section>
            <section style={{
                display: 'flex',
                justifyContent: 'center'
            }}>
                <StepperCustom
                    // sx={{ maxWidth: "400px" }}
                    step={step}
                    setStep={(num: number) => {
                        // dispatch(setStep(num));
                        setStep(num)
                    }}
                    stepLabel={allStep}
                    view
                />
            </section>
            {step === 0 && <MyCart />}
            {step === 1 && <History />}


        </div>
    )
}

const MyCart = () => {
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [data, setData] = useState<any[]>([]);

    const loadData = useCallback(async () => {

        try {

            const res = await MyOnlineCourseShoppingCartApi.list();
            const data = res.data
            if (data) {
                setData(data);
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleDelete = async (id: any) => {
        await MyOnlineCourseShoppingCartApi.deleteById(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเรียบร้อย'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    const handleDeleteAll = async () => {
        await MyOnlineCourseShoppingCartApi.delete().then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเรียบร้อย'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    return (
        <div className='my-4'>
            <div style={{
                height: '500px',
                overflowY: 'auto'
            }}>
                {data.map((data: any, i: any) => {
                    return (
                        <div style={{
                            padding: '24px 16px',
                            borderRadius: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                            marginBottom: '20px',
                            background: "#F6F6F6"
                        }}>

                            <div>
                                {/* <Typography>#บิลเลขที่ {data?.online_course_no}</Typography> */}
                                <div style={{
                                    display: 'flex',
                                    gap: '5px'
                                }}>
                                    <Typography sx={{ fontWeight: '600', fontSize: '18px' }}>{data?.online_course_no}</Typography>
                                    <Typography sx={{ fontSize: '18px' }}>{data?.online_course_name}</Typography>
                                </div>
                                <Typography>{data?.online_course_teacher}</Typography>
                                <Typography>จำนวน 1 รายการ ราคา {data?.online_course_amount} บาท</Typography>


                            </div>
                            <div className="w-full flex justify-end">
                                <div className="flex gap-4">

                                    <ButtonPrimary
                                        onClick={() => {
                                            alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                                handleDelete(data?.id_shopping_cart)
                                            })
                                        }}
                                        mode="del"
                                        buttonName={'ลบ'}
                                        btnProps={{
                                            // width: "100px"
                                        }}
                                    />
                                    <ButtonPrimary
                                        onClick={() => {
                                            navigate(routeName.students.OnlineCourseDetail.replace(':id', `${data?.id_online_course}`))
                                        }}
                                        mode="add"
                                        buttonName={'ดูข้อมูล'}
                                        
                                        btnProps={{
                                            // width: "100px"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className='flex justify-center gap-4'>

                <ButtonPrimary
                    onClick={() => {
                        // handleCreate()
                        handleDeleteAll()
                    }}
                    mode='del'
                    buttonName={'ลบทั้งหมด'}
                    disabled={data.length === 0}
                />

                <ButtonPrimary
                    onClick={() => {
                        // handleCreate()
                        navigate(routeName.students.PaymentOnlineAllCourse)

                    }}
                    mode='add'
                    buttonName={'ชำระเงิน'}
                    disabled={data.length === 0}
                />
            </div>
        </div>
    )
}

const History = () => {
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10000);
    const [data, setData] = useState<any[]>([]);


    const loadData = useCallback(async () => {

        try {
            let condition: any = {

            };
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };


            const res = await PublishOnlineCourseApi.my_active(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
            
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    return (
        <div className='my-4'>
            <div style={{
                height: '500px',
                overflowY: 'auto'
            }}>
                {data.map((data: any, i: any) => {
                    return (
                        <div style={{
                            padding: '24px 16px',
                            borderRadius: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                            marginBottom: '20px',
                            background: "#F6F6F6"
                        }}>

                            <div>
                                {/* <Typography>#บิลเลขที่ 00000001</Typography> */}
                                <div style={{
                                    display: 'flex',
                                    gap: '5px'
                                }}>
                                    <Typography sx={{ fontWeight: '600', fontSize: '18px' }}>{data?.online_course_no}</Typography>
                                    <Typography sx={{ fontSize: '18px' }}>{data?.online_course_name}</Typography>
                                </div>
                                <Typography>{data?.online_course_teacher}</Typography>
                                <Typography>จำนวน 1 รายการ ราคา {data?.online_course_amount} บาท</Typography>


                            </div>
                            <div className="w-full flex justify-between">
                                <div style={{ width: '300px' }}>
                                    <StatusCustom
                                        disableMaxWidth
                                        text={renderStatus(data?.online_course_payment_status)}
                                        type={renderStatus(data?.online_course_payment_status)}
                                    />
                                </div>
                                <div className="flex gap-4">

                                    <ButtonPrimary
                                        onClick={() => {
                                            navigate(routeName.students.OnlineCourseDetail.replace(':id', `${data?.id_online_course}`))

                                        }}
                                        mode="add"
                                        buttonName={'ดูข้อมูล'}
                                        btnProps={{
                                            // width: "100px"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}